export default "__VITE_ASSET__Ch4MYOYq__"